import { Link } from 'react-router-dom';
import { ROUTES } from '@traction/shared';
import { Lightbulb, Users } from 'lucide-react';

/**
 * Placeholder for Needs ↔ Solutions matching.
 * Full product: capture user "offers" vs market "needs", then suggest fits beyond title-only search.
 */
export function MatchingHubPage() {
  return (
    <div className="mx-auto max-w-3xl space-y-8 p-6">
      <div>
        <h1 className="flex items-center gap-2 text-2xl font-semibold text-white">
          <Lightbulb className="h-7 w-7 text-amber-400" />
          Needs Match
        </h1>
        <p className="mt-2 text-cacao-muted">
          A roadmap area for TractionBee: track what you solve for (your offer) and what leads or
          companies need, then surface better fits than title-only search.
        </p>
      </div>

      <section className="space-y-3 rounded-xl border border-cacao-border bg-cacao-surface/40 p-5">
        <h2 className="flex items-center gap-2 text-lg font-medium text-white">
          <Users className="h-5 w-5 text-cacao-accent" />
          Two sides of the market
        </h2>
        <ul className="list-inside list-disc space-y-2 text-sm text-cacao-muted">
          <li>
            <span className="text-cacao-text">Your side</span> — e.g. fractional CTO looking for
            more build work; we store your skills, geography, and ideal engagement.
          </li>
          <li>
            <span className="text-cacao-text">Their side</span> — e.g. CEO needs MVP, interim CTO,
            or a hire; captured from Apollo signals, your notes, or (later) self-reported needs.
          </li>
        </ul>
      </section>

      <p className="text-sm">
        <Link to={ROUTES.LEADS} className="text-cacao-accent hover:underline">
          ← Back to Leads
        </Link>
      </p>
    </div>
  );
}
